import React from 'react'

export default function FaceFeature({ scaleX, fill }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M1.19 2.38C1.84722 2.38 2.38 1.84722 2.38 1.19C2.38 0.532784 1.84722 0 1.19 0C0.532784 0 0 0.532784 0 1.19C0 1.84722 0.532784 2.38 1.19 2.38Z"
        fill={fill} // "#FFDC2E"
      />
      <path
        d="M66.42 2.38C67.0772 2.38 67.61 1.84722 67.61 1.19C67.61 0.532784 67.0772 0 66.42 0C65.7628 0 65.23 0.532784 65.23 1.19C65.23 1.84722 65.7628 2.38 66.42 2.38Z"
        fill={fill} // "#FFDC2E"
      />
    </g>
  )
}
